import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getUserOrganizations = async({token}) => {
  const url = `${generateEndpoint("getUserOrganizations")}`;
  return fetchGet(url, token);
};
